<div class="col-md-12 grid-margin stretch-card">
    <div class="card">
        <div class="card-body">
            <div class="text-success h6 text-right" style="margin-top:-9px">
                <a [routerLink]="['/v/dashboard/home']"style="color: black;"title="Back To Home"><i class="fa fa-arrow-left"></i>&nbsp;Back To Home</a>
              </div>
            <h4 class="card-title mt-3">Change Password </h4>
            <form [formGroup]="formmaster" class="forms-sample enviornmentFilter pt-3">
                <div class="form-group col-md-4">
                    <label>Current Password</label>
                    <input [type]="show1?'text':'password'" formControlName="currentpassword" [class.is-invalid]="
                                    this.formmaster.get('currentpassword').touched &&
                                    this.formmaster.get('currentpassword').invalid" autocomplete="off"
                        class="form-control form-control-lg" id="currentpassword" placeholder="Enter Current Password">
                    <button (click)="onClick(1)" class="login-eye-button">
                        <i class="fa fa-eye" aria-hidden="true" *ngIf="!show1"></i>
                        <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="show1"></i>
                    </button>
                    <span class="mandatory-span"
                        *ngIf="this.formmaster.get('currentpassword').touched && this.formmaster.get('currentpassword').invalid">Current
                        Password is
                        required</span>
                </div>

                <div class="form-group col-md-4">
                    <label>New Password</label>
                    <input [type]="show2?'text':'password'" formControlName="newpassword" autocomplete="off"
                        [class.is-invalid]="
                                    this.formmaster.get('newpassword').touched &&
                                    this.formmaster.get('newpassword').invalid" class="form-control form-control-lg"
                        minlength="8" maxlength="20" id="newpassword" placeholder="Enter New Password">
                    <button (click)="onClick(2)" class="login-eye-button">
                        <i class="fa fa-eye" aria-hidden="true" *ngIf="!show2"></i>
                        <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="show2"></i>
                    </button>
                    <span class="mandatory-span" *ngIf="this.formmaster.get('newpassword').touched
                                        && this.formmaster.get('newpassword').value == ''">New Password is
                        required</span>
                    <span class="mandatory-span" *ngIf="this.formmaster.get('newpassword').touched
                                        && this.formmaster.get('newpassword').value != '' &&
                                        this.formmaster.get('newpassword').invalid">Invalid format</span>
                </div>

                <div class="form-group col-md-4">
                    <label>Confirm Password</label>
                    <input [type]="show3?'text':'password'" formControlName="confirmpassword" autocomplete="off"
                        [class.is-invalid]="
                                    this.formmaster.get('confirmpassword').touched &&
                                    this.formmaster.get('confirmpassword').invalid" minlength="8" maxlength="20"
                        class="form-control form-control-lg" id="confirmpassword" placeholder="Re-enter New Password">
                    <button (click)="onClick(3)" class="login-eye-button">
                        <i class="fa fa-eye" aria-hidden="true" *ngIf="!show3"></i>
                        <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="show3"></i>
                    </button>
                    <span class="mandatory-span" *ngIf="this.formmaster.get('confirmpassword').touched
                                        && this.formmaster.get('confirmpassword').value == ''">Confirm Password is
                        required</span>
                    <span class="mandatory-span" *ngIf="this.formmaster.get('confirmpassword').touched
                                        && this.formmaster.get('confirmpassword').value != '' &&
                                        this.formmaster.get('confirmpassword').invalid">Invalid format</span>
                </div>
                <div>
                    <label class="mandatory-span"
                        *ngIf=" (this.formmaster.get('confirmpassword').touched && this.formmaster.get('newpassword').touched) && (this.formmaster.get('newpassword').value != '' && this.formmaster.get('confirmpassword').value != '') && (this.formmaster.get('newpassword').invalid || this.formmaster.get('confirmpassword').invalid|| this.formmaster.get('confirmpassword').value != this.formmaster.get('newpassword').value)">Password
                        doesn't match.</label>
                </div>
                <div class="col-md-8">
                    <label><b>Note:</b> Password should be atleast 08 characters long.</label>
                </div>
                <div class="">
                    &nbsp;
                </div>

                <div class="col-md-12">
                    <button
                        [disabled]="this.formmaster.get('newpassword').invalid || this.formmaster.get('confirmpassword').value != this.formmaster.get('newpassword').value"
                        (click)="changePassword()" class="btn-sm btn btn-primary ml-2 save-button">
                        Change Password
                    </button>
                    <button (click)="Reset()" class="btn-sm btn btn-danger ml-2 reset-button">
                        Reset
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>